export class ListQueryExecutionsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListQueryExecutionsRequestFilters",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<ListQueryExecutionsRequestSortsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListQueryExecutionsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
